import type { PreChatForm } from './widgetConfig';

// TODO: got them from current live chat v1 api response, may need to unify data schema
// Enums for message types
export enum MessageType {
  TEXT = 'text',
  FILE = 'file',
  LINK = 'link',
  LOCATION = 'location',
  INTERACTIVE = 'interactive',
}

// Enums for message status
// TODO: these are different from the ones in the backend (e.g. has delivered & Replied, no Sending), may need to unify them
export enum MessageStatus {
  SENDING = 'Sending',
  SENT = 'Sent',
  READ = 'Read',
  FAILED = 'Failed',
}

// Web client sender information
export interface WebClientSender {
  createdAt: string;
  ipAddress: string;
  locale: string;
  name: string;
  onlineStatus: string;
  updatedAt: string;
  webClientUUID: string;
}

// Uploaded file information
export interface UploadedFile {
  blobContainer?: string;
  channel?: string;
  displayName?: string;
  fileId: string;
  fileSize: number;
  fileType?: string;
  filename: string;
  metadata?: Record<string, unknown>;
  mimeType: string;
  thumbnailUrl?: string;
  url: string;
}

export interface Button {
  id: string;
  title: string;
  action: { type: string };
}

export enum ContactFormFieldType {
  TEXT = 'text',
  PHONE = 'phone',
  EMAIL = 'email',
  CHECKBOX = 'checkbox',
}

export interface ContactFormField {
  id: string;
  label: string;
  type: ContactFormFieldType;
  placeholder?: string;
  required?: boolean;
  default_value?: string;
  description?: string;
  value: string;
}

export interface LinkMessageMessageObject {
  link_message: {
    url?: string;
    title?: string;
    description?: string;
    image_url?: string;
  };
}

export interface ContactFormMessageObject {
  contact_form: {
    type: 'livechatv2_contact_form' | 'livechatv2_sms_contact_form';
    fields?: ContactFormField[];
  };
}

export interface QuickReplyMessageObject {
  quickReplyMessage: {
    buttons?: Button[];
  };
}

export type LiveChatV2MessageObject =
  | LinkMessageMessageObject
  | ContactFormMessageObject
  | QuickReplyMessageObject;

export interface ExtendedMessagePayloadDetail {
  liveChatV2MessageObject?: LiveChatV2MessageObject;
}

export interface ExtendedMessagePayload {
  extendedMessagePayloadDetail?: ExtendedMessagePayloadDetail;
  extendedMessageType?: number;
}

// Main message interface based on API response
export interface Message {
  analyticTags: unknown[];
  channel: string;
  channelIdentityId: string;
  channelName: string;
  companyId: string;
  conversationId: string;
  createdAt: string;
  deliveryType: string;
  extendedMessagePayload?: ExtendedMessagePayload;
  id: number | string; // taking string for temporary optimistic message id (messageChecksum)
  isFromImport: boolean;
  isSandbox: boolean;
  isSentFromSleekflow: boolean;
  messageChecksum: string;
  messageContent?: string;
  messageType: MessageType;
  metadata: Record<string, unknown>;
  originalUploadedFiles?: File[]; // frontend only, for retry message
  preChatForm?: PreChatForm;
  status: MessageStatus;
  timestamp: number; // TODO: backlog, unify timestamp to be in milliseconds (13 digits)
  updatedAt: string;
  uploadedFiles: UploadedFile[];
  webClientSender: WebClientSender;
}
